<template>
    <div class="modal-background"></div>
    <div class="modal-container">
        <v-btn @click="$emit('close-modal')" variant="text" class="close">
        <img src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/34acc885-1b03-4a5a-b827-489477f81a78.svg"
            alt="">
        </v-btn>
        <div v-if="loaded">

            <div v-if="eventSelected.file_url" class="content-container">
                <video width="290" height="150" controls v-if="fileType == 'video'" :src="filePreview" />
                <img v-if="fileType == 'img'" style="width: 100%;" :src="filePreview" alt="">

            </div>

            <div class="event-card">

                <div class="top">

                    <div class="date-wrapper">
                        <p class="month">{{ getMonthName(eventSelected.date) }}</p>
                        <p class="day">{{ getDay(eventSelected.date) }}</p>
                    </div>
                    <div class="info-wrapper">
                        <p class="title">{{ eventSelected.name }}</p>
                        <div style="display: flex; align-items: center">
                            <img src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/dd2fbbb0-014e-4d4b-a8ed-bdac97fd652c.svg"
                                alt="">
                            <span style="font-size: 12px;">{{ eventSelected.start_at }} - {{ eventSelected.end_at }}</span>
                            <img style="margin-left: 5%;" src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/52dd6eb8-c587-49ed-a206-71f0bee9bee2.svg"
                                alt="">
                            <span style="font-size: 12px;">{{ eventSelected.modality.charAt(0).toUpperCase() + eventSelected.modality.slice(1) }}</span>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <p class="description">{{ eventSelected.description }}</p>
                </div>
            </div>


            <v-btn style="margin-top: 5%; margin-bottom: 5%;" v-if="option == 'unsubscribe'" @click="unsubscriptionClicked" width="90%" variant="tonal" color="#EB3030"
                class="text-none">Cancelar
                presença</v-btn>
            <v-btn style="margin-top: 5%; margin-bottom: 5%;"  v-if="option == 'subscribe'" width="90%" @click="subscriptionClicked" color="#660099"
                class="text-none">Confirmar
                presença</v-btn>
        </div>
        <v-progress-circular
            v-else
            indeterminate
            color="#BC4AFF"
            :size="70"
            :width="7"
            style="margin-top: 25%;"
        ></v-progress-circular>
    </div>
</template>

<script setup>
import { defineProps, onMounted, ref, defineEmits } from 'vue';
import requestApi from '@/utils/requestApi'
import { useGlobalStateStore } from '../../../../store';

const globalStateStore = useGlobalStateStore();

const props = defineProps(['eventId', 'option', 'enrollmentId'])
const emits = defineEmits(['close-modal', 'refresh-calendar'])

const eventSelected = ref({})
const filePreview = ref('')
const fileType = ref('')
const loaded = ref(false)

async function loadEventDetails() {
    const response = await requestApi(
        {
            url: `/v2/gatherings/${props.eventId}`,
            method: 'get',
            headers: {
                BCS: globalStateStore.uuid,
                'Content-Type': 'application/json',
            }
        }
    )
    eventSelected.value = response.data
    checkGathering()
}

function getDay(key) {
    let dateArray = key.split("-");
    let year = dateArray[0];
    let month = dateArray[1] - 1;
    let date = dateArray[2].slice(0, 2);
    let _entryDate = new Date(year, month, date);
    return _entryDate.getDate();
}

function getMonthName(date) {
    const monthNames = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ];
    return monthNames[new Date(date).getMonth()].substr(0, 3)
}

async function subscriptionClicked() {
    await requestApi({
        url: `/v2/gatherings/${props.eventId}/enrollments`,
        method: 'post',
        headers: {
            BCS: globalStateStore.uuid,
            'Content-Type': 'application/json',
        }
    }).then(() => {
        emits('close-modal')
        emits('refresh-calendar')
    })
}

async function unsubscriptionClicked() {
    await requestApi({
        url: `/v2/gatherings/${props.eventId}/enrollments/${props.enrollmentId}`,
        method: 'delete',
        headers: {
            BCS: globalStateStore.uuid,
            'Content-Type': 'application/json',
        }
    }).then(() => {
        emits('close-modal')
        emits('refresh-calendar')
    })
}

onMounted(() => {
    loadEventDetails()
})

async function checkGathering() {
    if (eventSelected.value.file_url) {
        let blob = await fetch(eventSelected.value.file_url).then(r => r.blob());
        filePreview.value = eventSelected.value.file_url
        if (blob.type.includes('image')) {
            fileType.value = "img"
        } else {
            fileType.value = 'video'
        }
    }
    loaded.value = true
}

</script>

<style scoped>
.modal-background {
    width: 100%;
    height: 100%;
    background: black;
    opacity: 0.4;
    position: absolute;
    top: 0;
    z-index: 2;
}

.modal-container {
    min-height: 225px;
    max-height: 350px;
    width: 92%;
    position: absolute;
    top: 15%;
    left: 4%;
    border-radius: 12px;
    background-color: white;
    z-index: 2;
    padding-bottom: 10px;
    overflow-y: auto;
    overflow-x: hidden;
}

.content-container {
    width: 100%;
    height: 150px;

}

.event-card {
    width: 90%;
    margin: 15% 5% 0% 5%;
    border-radius: 8px;
    border: 1px solid var(--e-8-e-8-e-8, #E8E8E8);
    background: var(--f-9-f-9-f-9, #F9F9F9);
    display: flex;
    flex-direction: column;
}

.event-card .top {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px;
}

.event-card .description {
    color: #565656;
    width: 90%;
    margin-left: 5%;
    font-size: 9px;
    text-align: start;
    margin-bottom: 10px;
}

.date-wrapper {
    border-radius: 8px;
    border: 1px solid var(--eccdff, #ECCDFF);
    background: var(--faf-2-ff, #FAF2FF);
    width: 55px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-right: 10px;
}

.event-card .title {
    font-weight: bold;
}

.close {
    position: absolute !important;
    left: 80%;
    top: 3%;
    z-index: 1;
}

.close img {
    width: 30px;
}

.month {
    font-size: 14px;
    color: #BC4AFF;
}

.day {
    font-weight: bold;
    font-size: 18px;
    color: #370053;
}

.info-wrapper {
    width: 70%;
    text-align: left;
}
</style>